import {
  Car,
  CarPriceRange,
  FuelType,
  Prop,
  Transmission,
} from "../types/index";

export const cars: Car[] = [
  {
    id: "0",
    make: "BMW",
    model: "2 series",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 120,
      [CarPriceRange.ThreeDays]: 100,
      [CarPriceRange.EightDays]: 90,
      [CarPriceRange.TwentyFiveDays]: 80,
      [CarPriceRange.LongTerm]: 66.67,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "3.0",
    deposit: 500,
    dailyKmIncluded: 200,
    additionalKmPrice: 0.5,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.Bluetooth,
      Prop.ForwardCollisionWarning,
    ],
  },
  {
    id: "1",
    make: "BMW",
    model: "X5",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 150,
      [CarPriceRange.ThreeDays]: 140,
      [CarPriceRange.EightDays]: 130,
      [CarPriceRange.TwentyFiveDays]: 120,
      [CarPriceRange.LongTerm]: 105,
    },
    imagesAmount: 8,
    fuelType: FuelType.Diesel,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "3.0",
    deposit: 2000,
    dailyKmIncluded: 200,
    additionalKmPrice: 1,
    productionYear: 2018,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "2",
    make: "Mercedes-Benz",
    model: "C 200 Cabrio",
    isCabrio: true,
    logo: "mercedes-benz.webp",
    price: {
      [CarPriceRange.OneDay]: 150,
      [CarPriceRange.ThreeDays]: 150,
      [CarPriceRange.EightDays]: 140,
      [CarPriceRange.TwentyFiveDays]: 130,
      [CarPriceRange.LongTerm]: 115,
    },
    imagesAmount: 5,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "2.0L",
    deposit: 1500,
    dailyKmIncluded: 100,
    additionalKmPrice: 10,
    productionYear: 2020,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "3",
    make: "Mercedes-Benz",
    model: "C 200 Cabrio AMG Line",
    isCabrio: true,
    logo: "mercedes-benz.webp",
    price: {
      [CarPriceRange.OneDay]: 150,
      [CarPriceRange.ThreeDays]: 150,
      [CarPriceRange.EightDays]: 140,
      [CarPriceRange.TwentyFiveDays]: 130,
      [CarPriceRange.LongTerm]: 120,
    },
    imagesAmount: 4,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "2.0L",
    deposit: 1500,
    dailyKmIncluded: 200,
    additionalKmPrice: 10,
    productionYear: 2023,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "4",
    make: "Mercedes-Benz",
    model: "E 200",
    logo: "mercedes-benz.webp",
    price: {
      [CarPriceRange.OneDay]: 150,
      [CarPriceRange.ThreeDays]: 150,
      [CarPriceRange.EightDays]: 135,
      [CarPriceRange.TwentyFiveDays]: 120,
      [CarPriceRange.LongTerm]: 105,
    },
    imagesAmount: 6,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 500,
    dailyKmIncluded: 200,
    additionalKmPrice: 0.5,
    productionYear: 2020,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.HeatedSeats,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "5",
    make: "BMW",
    model: "X5 XDrive45e",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 400,
      [CarPriceRange.ThreeDays]: 380,
      [CarPriceRange.EightDays]: 350,
      [CarPriceRange.TwentyFiveDays]: 300,
      [CarPriceRange.LongTerm]: 280,
    },
    imagesAmount: 8,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "3.0L",
    deposit: 2000,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.HeatedSeats,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "6",
    make: "Hyundai",
    model: "Tucson",
    logo: "hyundai.webp",
    price: {
      [CarPriceRange.OneDay]: 70,
      [CarPriceRange.ThreeDays]: 70,
      [CarPriceRange.EightDays]: 65,
      [CarPriceRange.TwentyFiveDays]: 60,
      [CarPriceRange.LongTerm]: 55,
    },
    imagesAmount: 4,
    fuelType: FuelType.Diesel,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "1.6L",
    deposit: 300,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.3,
    productionYear: 2021,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
    ],
  },
  {
    id: "7",
    make: "BMW",
    model: "1 series",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 100,
      [CarPriceRange.ThreeDays]: 90,
      [CarPriceRange.EightDays]: 85,
      [CarPriceRange.TwentyFiveDays]: 80,
      [CarPriceRange.LongTerm]: 70,
    },
    imagesAmount: 7,
    fuelType: FuelType.Diesel,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "1.8L",
    deposit: 500,
    dailyKmIncluded: 200,
    additionalKmPrice: 0.5,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "8",
    make: "BMW",
    model: "2 series Cabrio",
    isCabrio: true,
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 150,
      [CarPriceRange.ThreeDays]: 150,
      [CarPriceRange.EightDays]: 120,
      [CarPriceRange.TwentyFiveDays]: 100,
      [CarPriceRange.LongTerm]: 80,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "2.0L",
    deposit: 1000,
    dailyKmIncluded: 250,
    additionalKmPrice: 1,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "9",
    make: "Ford",
    model: "Mustang 2.3 Cabrio",
    isCabrio: true,
    logo: "mustang.webp",
    price: {
      [CarPriceRange.OneDay]: 250,
      [CarPriceRange.ThreeDays]: 200,
      [CarPriceRange.EightDays]: 170,
      [CarPriceRange.TwentyFiveDays]: 150,
      [CarPriceRange.LongTerm]: 130,
    },
    imagesAmount: 9,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "2.3L",
    deposit: 1500,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2023,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "10",
    make: "BMW",
    model: "X1",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 120,
      [CarPriceRange.ThreeDays]: 100,
      [CarPriceRange.EightDays]: 90,
      [CarPriceRange.TwentyFiveDays]: 80,
      [CarPriceRange.LongTerm]: 70,
    },
    imagesAmount: 10,
    fuelType: FuelType.Diesel,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 500,
    dailyKmIncluded: 200,
    additionalKmPrice: 0.5,
    productionYear: 2023,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.Camera360,
    ],
  },
  {
    id: "11",
    make: "KIA",
    model: "Sportage",
    logo: "kia.webp",
    price: {
      [CarPriceRange.OneDay]: 90,
      [CarPriceRange.ThreeDays]: 80,
      [CarPriceRange.EightDays]: 75,
      [CarPriceRange.TwentyFiveDays]: 70,
      [CarPriceRange.LongTerm]: 60,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 500,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.3,
    productionYear: 2025,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.Camera360,
    ],
  },
  {
    id: "12",
    make: "BMW",
    model: "X6",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 500,
      [CarPriceRange.ThreeDays]: 400,
      [CarPriceRange.EightDays]: 380,
      [CarPriceRange.TwentyFiveDays]: 350,
      [CarPriceRange.LongTerm]: 320,
    },
    imagesAmount: 6,
    fuelType: FuelType.Diesel,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "3.0L",
    deposit: 3000,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2023,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.Camera360,
    ],
  },
  {
    id: "13",
    make: "Volkswagen",
    model: "Tiguan",
    logo: "volkswagen.webp",
    price: {
      [CarPriceRange.OneDay]: 80,
      [CarPriceRange.ThreeDays]: 75,
      [CarPriceRange.EightDays]: 70,
      [CarPriceRange.TwentyFiveDays]: 60,
      [CarPriceRange.LongTerm]: 50,
    },
    imagesAmount: 9,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 500,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.5,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.BackViewCamera,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
    ],
  },
  {
    id: "14",
    make: "Toyota",
    model: "C-HR Hybrid",
    logo: "toyota.webp",
    price: {
      [CarPriceRange.OneDay]: 60,
      [CarPriceRange.ThreeDays]: 55,
      [CarPriceRange.EightDays]: 50,
      [CarPriceRange.TwentyFiveDays]: 45,
      [CarPriceRange.LongTerm]: 40,
    },
    imagesAmount: 9,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 300,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.3,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
    ],
  },
  {
    id: "15",
    make: "Volkswagen",
    model: "T-Roc Cabrio",
    isCabrio: true,
    logo: "volkswagen.webp",
    price: {
      [CarPriceRange.OneDay]: 100,
      [CarPriceRange.ThreeDays]: 90,
      [CarPriceRange.EightDays]: 85,
      [CarPriceRange.TwentyFiveDays]: 80,
      [CarPriceRange.LongTerm]: 70,
    },
    imagesAmount: 9,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "2.0L",
    deposit: 500,
    dailyKmIncluded: 250,
    additionalKmPrice: 1,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.BackViewCamera,
    ],
  },
  {
    id: "16",
    make: "Toyota",
    model: "Corolla Hybrid",
    logo: "toyota.webp",
    price: {
      [CarPriceRange.OneDay]: 70,
      [CarPriceRange.ThreeDays]: 60,
      [CarPriceRange.EightDays]: 50,
      [CarPriceRange.TwentyFiveDays]: 40,
      [CarPriceRange.LongTerm]: 35,
    },
    imagesAmount: 7,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 300,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.3,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
    ],
  },
  {
    id: "17",
    make: "Porsche",
    model: "Cayenne",
    logo: "porsche.webp",
    price: {
      [CarPriceRange.OneDay]: 500,
      [CarPriceRange.ThreeDays]: 400,
      [CarPriceRange.EightDays]: 350,
      [CarPriceRange.TwentyFiveDays]: 300,
      [CarPriceRange.LongTerm]: 280,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "3.0L",
    deposit: 3000,
    dailyKmIncluded: 200,
    additionalKmPrice: 3,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
      Prop.ForwardCollisionWarning,
    ],
  },
  {
    id: "18",
    make: "MINI",
    model: "Cooper Cabrio",
    isCabrio: true,
    logo: "mini.webp",
    price: {
      [CarPriceRange.OneDay]: 90,
      [CarPriceRange.ThreeDays]: 80,
      [CarPriceRange.EightDays]: 70,
      [CarPriceRange.TwentyFiveDays]: 60,
      [CarPriceRange.LongTerm]: 50,
    },
    imagesAmount: 5,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "2.0L",
    deposit: 500,
    dailyKmIncluded: 200,
    additionalKmPrice: 0.5,
    productionYear: 2020,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
    ],
  },
  {
    id: "19",
    make: "BMW",
    model: "530E xDrive",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 300,
      [CarPriceRange.ThreeDays]: 250,
      [CarPriceRange.EightDays]: 220,
      [CarPriceRange.TwentyFiveDays]: 200,
      [CarPriceRange.LongTerm]: 180,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "3.0L",
    deposit: 1000,
    dailyKmIncluded: 200,
    additionalKmPrice: 1,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
      Prop.Camera360,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.HeatedSeats,
      Prop.WirelessCharging,
    ],
  },
  {
    id: "20",
    make: "Mercedes-Benz",
    model: "CLA 45 AMG",
    logo: "mercedes-benz.webp",
    price: {
      [CarPriceRange.OneDay]: 400,
      [CarPriceRange.ThreeDays]: 350,
      [CarPriceRange.EightDays]: 300,
      [CarPriceRange.TwentyFiveDays]: 250,
      [CarPriceRange.LongTerm]: 220,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "2.0L",
    deposit: 2000,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2023,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.WirelessCharging,
    ],
  },
  {
    id: "21",
    make: "Tesla",
    model: "Model 3",
    logo: "tesla.webp",
    price: {
      [CarPriceRange.OneDay]: 80,
      [CarPriceRange.ThreeDays]: 70,
      [CarPriceRange.EightDays]: 60,
      [CarPriceRange.TwentyFiveDays]: 50,
      [CarPriceRange.LongTerm]: 40,
    },
    imagesAmount: 9,
    fuelType: FuelType.Electric,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "Electric",
    deposit: 500,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.5,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.WirelessCharging,
    ],
  },
  {
    id: "22",
    make: "Toyota",
    model: "RAV4 Hybrid",
    logo: "toyota.webp",
    price: {
      [CarPriceRange.OneDay]: 80,
      [CarPriceRange.ThreeDays]: 70,
      [CarPriceRange.EightDays]: 65,
      [CarPriceRange.TwentyFiveDays]: 60,
      [CarPriceRange.LongTerm]: 55,
    },
    imagesAmount: 8,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 500,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.3,
    productionYear: 2020,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.WirelessCharging,
    ],
  },
  {
    id: "23",
    make: "Hyundai",
    model: "Tucson Hybrid",
    logo: "hyundai.webp",
    price: {
      [CarPriceRange.OneDay]: 80,
      [CarPriceRange.ThreeDays]: 70,
      [CarPriceRange.EightDays]: 65,
      [CarPriceRange.TwentyFiveDays]: 60,
      [CarPriceRange.LongTerm]: 55,
    },
    imagesAmount: 9,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "1.6L",
    deposit: 300,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.3,
    productionYear: 2023,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
    ],
  },
  {
    id: "24",
    make: "Aston Martin",
    model: "Vantage",
    logo: "aston martin.webp",
    price: {
      [CarPriceRange.OneDay]: 1400,
      [CarPriceRange.ThreeDays]: 1300,
      [CarPriceRange.EightDays]: 1200,
      [CarPriceRange.TwentyFiveDays]: 1000,
      [CarPriceRange.LongTerm]: 800,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 2,
    engine: "6.0L",
    deposit: 5000,
    dailyKmIncluded: 150,
    additionalKmPrice: 5,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "25",
    make: "Porsche",
    model: "Macan S",
    logo: "porsche.webp",
    price: {
      [CarPriceRange.OneDay]: 400,
      [CarPriceRange.ThreeDays]: 350,
      [CarPriceRange.EightDays]: 300,
      [CarPriceRange.TwentyFiveDays]: 250,
      [CarPriceRange.LongTerm]: 220,
    },
    imagesAmount: 8,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 2000,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.KeylessEntry,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "26",
    make: "Volkswagen",
    model: "Touran",
    logo: "volkswagen.webp",
    price: {
      [CarPriceRange.OneDay]: 80,
      [CarPriceRange.ThreeDays]: 75,
      [CarPriceRange.EightDays]: 70,
      [CarPriceRange.TwentyFiveDays]: 60,
      [CarPriceRange.LongTerm]: 50,
    },
    imagesAmount: 6,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 500,
    dailyKmIncluded: 250,
    additionalKmPrice: 0.5,
    productionYear: 2023,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
    ],
  },
  {
    id: "27",
    make: "BMW",
    model: "420 Cabrio",
    logo: "bmw.webp",
    isCabrio: true,
    price: {
      [CarPriceRange.OneDay]: 300,
      [CarPriceRange.ThreeDays]: 250,
      [CarPriceRange.EightDays]: 220,
      [CarPriceRange.TwentyFiveDays]: 200,
      [CarPriceRange.LongTerm]: 180,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "2.0L",
    deposit: 2000,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
    ],
  },
  {
    id: "28",
    make: "BMW",
    model: "M4 Competition",
    isCabrio: true,
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 800,
      [CarPriceRange.ThreeDays]: 700,
      [CarPriceRange.EightDays]: 600,
      [CarPriceRange.TwentyFiveDays]: 500,
      [CarPriceRange.LongTerm]: 450,
    },
    imagesAmount: 8,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 4,
    engine: "3.0L",
    deposit: 4000,
    dailyKmIncluded: 150,
    additionalKmPrice: 3,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
    ],
  },
  {
    id: "29",
    make: "Range Rover",
    model: "Evoque R-Dynamic",
    logo: "range rover.webp",
    price: {
      [CarPriceRange.OneDay]: 250,
      [CarPriceRange.ThreeDays]: 200,
      [CarPriceRange.EightDays]: 180,
      [CarPriceRange.TwentyFiveDays]: 150,
      [CarPriceRange.LongTerm]: 130,
    },
    imagesAmount: 8,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 1500,
    dailyKmIncluded: 250,
    additionalKmPrice: 2,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
    ],
  },
  {
    id: "30",
    make: "BMW",
    model: "X2",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 120,
      [CarPriceRange.ThreeDays]: 100,
      [CarPriceRange.EightDays]: 90,
      [CarPriceRange.TwentyFiveDays]: 80,
      [CarPriceRange.LongTerm]: 70,
    },
    imagesAmount: 9,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 700,
    dailyKmIncluded: 200,
    additionalKmPrice: 0.5,
    productionYear: 2023,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
    ],
  },
  {
    id: "31",
    make: "Lexus",
    model: "RX 300",
    logo: "lexus.webp",
    price: {
      [CarPriceRange.OneDay]: 150,
      [CarPriceRange.ThreeDays]: 130,
      [CarPriceRange.EightDays]: 120,
      [CarPriceRange.TwentyFiveDays]: 100,
      [CarPriceRange.LongTerm]: 80,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 1000,
    dailyKmIncluded: 250,
    additionalKmPrice: 1,
    productionYear: 2019,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
    ],
  },
  {
    id: "32",
    make: "Mercedes-Benz",
    model: "S 350D",
    logo: "mercedes-benz.webp",
    price: {
      [CarPriceRange.OneDay]: 400,
      [CarPriceRange.ThreeDays]: 380,
      [CarPriceRange.EightDays]: 350,
      [CarPriceRange.TwentyFiveDays]: 330,
      [CarPriceRange.LongTerm]: 300,
    },
    imagesAmount: 8,
    fuelType: FuelType.Diesel,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 3000,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2020,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "33",
    make: "Mercedes-Benz",
    model: "G 63 AMG",
    logo: "mercedes-benz.webp",
    price: {
      [CarPriceRange.OneDay]: 600,
      [CarPriceRange.ThreeDays]: 550,
      [CarPriceRange.EightDays]: 500,
      [CarPriceRange.TwentyFiveDays]: 450,
      [CarPriceRange.LongTerm]: 400,
    },
    imagesAmount: 8,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "4.0L",
    deposit: 3000,
    dailyKmIncluded: 200,
    additionalKmPrice: 3,
    productionYear: 2020,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
    ],
  },
  {
    id: "34",
    make: "BMW",
    model: "730",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 400,
      [CarPriceRange.ThreeDays]: 350,
      [CarPriceRange.EightDays]: 330,
      [CarPriceRange.TwentyFiveDays]: 300,
      [CarPriceRange.LongTerm]: 280,
    },
    imagesAmount: 8,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "3.0L",
    deposit: 3000,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "35",
    make: "BMW",
    model: "320D",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 250,
      [CarPriceRange.ThreeDays]: 200,
      [CarPriceRange.EightDays]: 180,
      [CarPriceRange.TwentyFiveDays]: 150,
      [CarPriceRange.LongTerm]: 130,
    },
    imagesAmount: 9,
    fuelType: FuelType.Diesel,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "2.0L",
    deposit: 1000,
    dailyKmIncluded: 200,
    additionalKmPrice: 1,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "36",
    make: "BMW",
    model: "X7 M50i",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 600,
      [CarPriceRange.ThreeDays]: 500,
      [CarPriceRange.EightDays]: 450,
      [CarPriceRange.TwentyFiveDays]: 400,
      [CarPriceRange.LongTerm]: 350,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 7,
    engine: "4.4L",
    deposit: 3000,
    dailyKmIncluded: 250,
    additionalKmPrice: 3,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "37",
    make: "Corvette",
    model: "Stingray C8",
    isCabrio: true,
    logo: "corvette.webp",
    price: {
      [CarPriceRange.OneDay]: 1000,
      [CarPriceRange.ThreeDays]: 900,
      [CarPriceRange.EightDays]: 800,
      [CarPriceRange.TwentyFiveDays]: 700,
      [CarPriceRange.LongTerm]: 600,
    },
    imagesAmount: 9,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 2,
    engine: "6.2L",
    deposit: 4000,
    dailyKmIncluded: 150,
    additionalKmPrice: 3,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "38",
    make: "BMW",
    model: "X7 730",
    logo: "bmw.webp",
    price: {
      [CarPriceRange.OneDay]: 600,
      [CarPriceRange.ThreeDays]: 500,
      [CarPriceRange.EightDays]: 450,
      [CarPriceRange.TwentyFiveDays]: 400,
      [CarPriceRange.LongTerm]: 350,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 7,
    engine: "3.0L",
    deposit: 3000,
    dailyKmIncluded: 250,
    additionalKmPrice: 3,
    productionYear: 2025,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "39",
    make: "Lamborghini",
    model: "Huracan Spyder",
    isCabrio: true,
    logo: "lamborghini.webp",
    price: {
      [CarPriceRange.OneDay]: 1700,
      [CarPriceRange.ThreeDays]: 1600,
      [CarPriceRange.EightDays]: 1500,
      [CarPriceRange.TwentyFiveDays]: 1300,
      [CarPriceRange.LongTerm]: 1200,
    },
    imagesAmount: 9,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 2,
    engine: "5.2L",
    deposit: 6000,
    dailyKmIncluded: 150,
    additionalKmPrice: 6,
    productionYear: 2022,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
  {
    id: "40",
    make: "Mercedes-Benz",
    model: "GLC 300 AMG Line",
    logo: "mercedes-benz.webp",
    price: {
      [CarPriceRange.OneDay]: 1700,
      [CarPriceRange.ThreeDays]: 1600,
      [CarPriceRange.EightDays]: 1400,
      [CarPriceRange.TwentyFiveDays]: 1200,
      [CarPriceRange.LongTerm]: 1000,
    },
    imagesAmount: 10,
    fuelType: FuelType.Petrol,
    transmission: Transmission.Automatic,
    seats: 5,
    engine: "3.0L",
    deposit: 1500,
    dailyKmIncluded: 200,
    additionalKmPrice: 2,
    productionYear: 2024,
    props: [
      Prop.AirConditioning,
      Prop.Bluetooth,
      Prop.Navigation,
      Prop.FrontParkingSensors,
      Prop.RearParkingSensors,
      Prop.CruiseControl,
      Prop.AndroidAuto,
      Prop.AppleCarPlay,
      Prop.USBPort,
      Prop.ForwardCollisionWarning,
      Prop.WirelessCharging,
      Prop.BackViewCamera,
      Prop.LeatherInterior,
      Prop.StartStopButton,
      Prop.Camera360,
    ],
  },
];

export const makes = [...new Set(cars.map((car) => car.make))];
